import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import style from "./AboutUs.module.css";
import Card from "./Card/Card";
import Cards from "./Cards/Cards";

const AboutUs = () => {
  return (
    <div className={style.about}>
      <Header />
      <div className={style.about__frst_floor}>
        <p className={style.about__title}>About</p>
        <p className={style.about__desc}>
          We strive to offer every individual customer the best possible PC
          experience from start to finish no matter what PC they have purchased
          from us. PC Engine is approved by the U.S. General Services Administration (GSA Schedule) under contract number GS-35F-430AA. With unlimited customization options featuring the latest leading edge components and innovative powerful cooling solutions, PC Engine offers one of the world’s most advanced workstation computers.
        </p>
      </div>

      <div className={style.container}>
        <div className={style.about__scnd_floor}>
          <div>
            <img
              className={style.scnd__img}
              src="https://cdn.originpc.com/img/company/about/genesis-hero-left.png"
              alt="err"
            />
          </div>
          <div className={style.aboutt}>
            <p className={style.about__title}>Mission</p>
            <p className={style.about__description}>
              Our mission is to create the absolute best custom PCs for every
              individual’s specific wants and needs. Whether you want the most
              realistic and immersive gaming experience or ultra-fast
              workstation performance, every PC Engine is up to the task.
            </p>
          </div>
        </div>
      </div>
      <div className={style.thrd__floor}>
        <p className={style.about__title_thrd}>Legacy</p>
        <p className={style.about__description_thrd}>
          Founded in 2009, the team sought out to continue building custom
          high-performance PCs and providing world-class support. With several
          years of experience in PC building, support, and service, PC Engine is
          comprised of industry veterans that have helped grow the
          professionally-built PC market.
        </p>
      </div>
      <div className={style.container}>
        <div className={style.about__scnd_floor}>
          <div>
            <img
              className={style.scnd__img}
              src="https://cdn.originpc.com/img/company/about/millennium-corsair.png"
              alt="err"
            />
          </div>
          <div className={style.aboutt}>
            <p className={style.about__title}>Looking Forward</p>
            <p className={style.about__description}>
              In 2019, PC Engine was acquired by CORSAIR, combining expertise in
              PC building and expansive PC hardware to grow PC Engine even more.
              With iCUE, Hydro X Series custom cooling, unique system designs,
              and internal components, CORSAIR and PC Engine will continue to
              collaborate and bring a greater PC experience to the world.
            </p>
          </div>
        </div>
      </div>

      <div className={style.pillars}>
        <div className={style.container}>
          <h1 className={style.pillars__title}>Pillars</h1>
          <div className={style.about__pillars}>
            <Cards
              className={style.cards}
              imgUrl="https://cdn.originpc.com/img/company/about/performance.jpg"
              title="Performance"
              description="We use only superior components paired with award-winning integration and offer professional overclocking to support the most demanding PC usage."
            />

            <Cards
              className={style.cards}
              imgUrl="https://cdn.originpc.com/img/company/about/support-2.jpg"
              title="Support"
              description="Contact our lifetime US-based support team at any time, available 24/7.
            All of our systems come with an indus."
            />

            <Cards
              className={style.cards}
              imgUrl="https://cdn.originpc.com/img/company/about/customization-2.jpg"
              title="Customization"
              description="Every PC we build is custom, hand-built to order by request."
            />
          </div>
        </div>
      </div>

      <div className={style.founders}>
        <div className={style.container}>
          <h2 className={style.founders__title}>Founders</h2>
          <p className={style.founders__description}>Former Alienware executives Kevin Wasielewski, Richard Cary, and Hector Penton formed PC Engine in Miami, Florida in 2009. The Engine name comes from their dedication to get back to the roots of building custom, high-performance computers for gamers and hardware enthusiasts.</p>
          <div className={style.card}>
            <Card
              name="Kevin Wasielewski"
              jobtitle="CEO, Co-Founder"
              description="Before starting PC Engine, Kevin Wasielewski gathered over 15 years of professional experience with leading companies such as Dell, Alienware, and GameStop. He is highly motivated and has held executive and senior level positions including vice president of marketing, global sales manager, and director of business development for Dell/Alienware. Kevin has expertise in multiple industries and channels of distribution, which has allowed him to create a collection of key contacts in the retail, technology, and gaming communities. He is an avid gamer and understands the technology and gaming industries both as a professional and as an enthusiast." />

            <Card
              name="Richard Cary"
              jobtitle="President, Co-Founder"
              description="Richard started working in the gaming computer industry with Alienware in 1999. He did everything and anything there was to do in order to learn the most he could about the company and industry. As time went on he began to focus on the manufacturing and supply chain side of things and became the Senior Vice President of Manufacturing, Supply chain and Logistics at Alienware. At PC Engine, he utilizes these same skills to focus on always making sure PC Engine is maintaining a focus on quality and performance." />


            <Card
              name="Hector Penton"
              jobtitle="COO, Co-Founder"
              description="Hector's love for PC gaming started in the early 90's and only grew from there. He grew up gaming along side the original founders of Alienware, so it came as no surprise when he started working with them by late 1998. During his 10+ years working there, he did everything involving customer service, sales and support. Now at PC Engine, his goal is to make sure the company sticks to its commitment of offering the best customization and performance and that the service and support of the brand is true to its customer's expectations. With a dedicated staff of hardcore enthusiasts, he works with every customer to make their dream PC a reality." />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;